<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jJql8y/tc-custom/9781480445109.jpg?1733124141612" alt="This image is the cover for the book Peaceable Kingdom"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Peaceable Kingdom
      </h1>
      <p class="bookDescription body article font2">
        <b>Eleven “impeccably crafted, painfully hilarious” tales of innocence lost and families in search of connection from the <i>New York Times</i>–bestselling author (<i>San Francisco Chronicle</i>).</b><br/>  <br/> A reluctant trophy wife on her Italian honeymoon; a young woman in love with her sister’s dead boyfriend; a lonely puppeteer flirting with the hostess of a children’s party; a teenage girl traveling to Paris with her father and, unexpectedly, his young girlfriend. Francine Prose’s characters inhabit a world of rich emotion and startling clarity, searching for connection in a world full of surprise and humor; they travel, love, break up, and start again. Even their animal companions—a gecko rescued from a wild party, a dog who bites a bride, a hamster who dies unexpectedly and sends a family on a journey to give it a proper funeral—shine with the emotional complexity and sly satire that make Prose’s work such a joy to experience.<br/>  <br/> In this collection, the <i>New York Times</i>–bestselling author and National Book Award finalist demonstrates the craft, humor, and piercing human insight that make her, in the words of Gary Shteyngart “one of a handful of truly indispensable American writers.”<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Francine Prose
      </h2>
      
      <p class="authorDescription body article">Francine Prose is the author of sixteen novels, including <i>A Changed Man</i>, winner of the Dayton Literary Peace Prize, and <i>Blue Angel</i>, a finalist for the National Book Award. Her most recent works of nonfiction include the highly acclaimed <i>Anne Frank: The Book, the Life, the Afterlife</i>, and the <i>New York Times</i> bestseller <i>Reading Like a Writer</i>. A former president of PEN American Center and a member of the American Academy of Arts and Letters, as well as the American Academy of Arts and Sciences, Prose is a highly regarded critic and essayist, and has taught literature and writing for more than twenty years at major universities. She is a distinguished writer in residence at Bard College, and she lives in New York City.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c5c0d880